export default __webpack_public_path__ + "static/media/plan.28a11c94.png";